import React from "react";
import { set } from "dot-prop-immutable";
import { message } from '@whalecloud/fdx';
import CommonCodeDrawer from '@whalecloud/page-builder-base-components/components/CommonCodeDrawer';
import { getLocale } from "@utils/util";

const valueKey = 'data.formItemSettings';

const StaticSettings = (props: any) => {
  const messages = getLocale();

  const { updateElement, element, treeData } = props;
  const { data: { formItemSettings = {} } = {} } = element;
  const onCreate = async (code: any) => {
    if (code) {
      const propName = `${valueKey}.treeData`;
      const newElement = set(element, propName, code);
      newElement.data.formItemSettings.autoInitialize = true;

      updateElement({
        element: newElement,
      });
      message.success(messages['PAGEBUIDER_MSG_SETTINGS_SUCCESS']);
    } else {
      message.error(messages['PAGEBUIDER_MSG_SETTINGS_FAIL']);
    }
  };

  const CodeDrawerProps = {
    value: JSON.stringify(treeData, null, '\t'),
    onClose: onCreate,
    title: `${messages['PAGEBUIDER_TITLE_STATIC']}(JSON)`,
    buttonText: messages['PAGEBUIDER_TITLE_STATIC']
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <CommonCodeDrawer {...CodeDrawerProps} />
    </div>
  );
};

export default StaticSettings;
